<script setup>
defineProps({
  image: {
    type: Object,
    default: () => {},
  },
  title: {
    type: String,
    default: () => '',
  },
  description: {
    type: String,
    default: () => '',
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
});
</script>
<template>
  <div
    :class="[
      'customs-services__item',
      backgroundColor === 'black' ? 'white' : 'black',
    ]"
  >
    <div v-if="image" class="customs-services__item-media">
      <NuxtImg
        v-if="image?.src"
        :src="image.src"
        :alt="image.alt"
        :height="image.height"
        :width="image.width"
        class="customs-services__item-image"
        loading="lazy"
      />
    </div>
    <div class="customs-services__item-info">
      <p
        v-if="title"
        class="mb-0 customs-services__item-title h4"
        v-html="title"
      ></p>
      <div
        v-if="description && description.length > 0"
        class="customs-services__item-description body-2-regular"
        v-html="description"
      ></div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.customs-services__item {
  display: flex;
  flex-direction: column;
  gap: 24px;
  @include media-breakpoint-up(sm) {
    gap: 40px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 40);
  }
  &-media {
    border-radius: 8px;
    aspect-ratio: 328/340;
    overflow: hidden;
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-radius, 8);
    }
  }
  &-image {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
  &-info {
    display: flex;
    flex-direction: column;
    gap: 16px;
    @include media-breakpoint-up(sm) {
      gap: 24px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 24);
    }
  }
  &-title {
    margin: 0;
    @include media-breakpoint-up(md) {
      padding-right: 56px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(padding-right, 56);
    }
  }
  &-description {
    padding-right: 16px;
    &:deep(p:last-child) {
      margin: 0;
    }
    @include media-breakpoint-up(sm) {
      padding-right: 2px;
    }
    @include media-breakpoint-up(md) {
      padding-right: 56px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(padding-right, 56);
    }
  }
}
</style>
